import store from '@/store'
import modelCreate from './../components/modelCreate.vue'
// import vue from 'vue'
// const that = vue.prototype
export default {
  // 车间型号
  className: 'shopManagement',
  fields: [
    {
      name: 'name',
      note: '型号名称',
      validators: [
        (val) => val ? null : '型号名称不可为空'
      ]
    },
    {
      name: 'parentNode',
      note: '所属车间',
      validators: [
        (val) => val ? null : '所属车间不可为空'
      ],
      listWhere: (where) => {
        where.type = 'workShop'
        if (store.state.user && store.state.user.allShopManagements !== 'Yes') {
          where.objectId.$in = store.state.user.shopManagements
          // where.objectId = store.state.user.shopManagements
        }
        // console.log(Object.values(where))
      }
    },
    {
      name: 'amountRatio2',
      note: '大类吨系数',
      validators: [
        (val) => val ? null : '车间型号吨系数不可为空'
      ]
    },
    {
      name: 'profitRatio2',
      note: '大类利系数',
      validators: [
        (val) => val ? null : '车间型号利系数不可为空'
      ]
    }
  ],
  search: [
    'name'
    // 'parentNode'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'model'
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
    },
    beforeSave ({ data }) {
      data.type = 'model'
      data.workShop = data.parentNode
    }
  },
  action: {
    create: store.state.user && store.state.user.authority.model.create
      ? {
        type: 'list',
        text: '新建',
        title: '添加车间',
        component: modelCreate
      } : false,
    edit: store.state.user && store.state.user.authority.model.edit ? {
      type: 'row',
      text: '编辑',
      title: '编辑车间',
      component: modelCreate
    } : false,
    delete: false
  }
}
